<template>
  <div class="tips-container">
    <p class="tips-title">温馨提示:</p>
    <ul>
      <li>
        {{tips}}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    props: ["tips"]
  };

</script>
<style lang="less" scoped>
  .tips-container {
    background: #f3f3f3;
    margin: 20px 15px 0;

    .tips-title {
      font-size: 14px;
      font-family: PingFang-SC-Medium;
      color: #fc542d;
      letter-spacing: 0;
      line-height: 26px;
    }

    li {
      font-size: 13px;
      font-family: PingFang-SC-Medium;
      color: #999999;
      letter-spacing: 0;
      line-height: 26px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Tips/index.vue